import React, { Component } from 'react'

export class TermsAndConditions extends Component {
  render() {
    return (
      <div>
        <h1>Terms And Conditions</h1>
      </div>
    )
  }
}

export default TermsAndConditions
